import { ConfigItem, SystemConfigKey } from '@/common/model/systemConfig'

export const extractSystemConfigValue = (
  configs: ConfigItem[],
  key: SystemConfigKey
): string | null => {
  const config = configs.find((config) => config.key === key)
  return config ? config.value : null
}
